module.exports = __webpack_public_path__ + "img/calendar-24.3b9b7dd4.svg";